import script from "./Book.vue?vue&type=script&setup=true&lang=js"
export * from "./Book.vue?vue&type=script&setup=true&lang=js"

import "./Book.vue?vue&type=style&index=0&id=3d792ccd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d792ccd"]])

export default __exports__